import React, {Fragment, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/Button';
import {addProductProduction, getProductOptions, previewProductionMaterials} from "../../actions/product";
import Select from 'react-select'
import {Form} from "react-bootstrap";
import {getParams, getSelectedOption} from "../../utils/hooks/getParams";
import moment from "moment";
import products from "./Products";
import ButtonLoader from "../layout/ButtonLoader";
import useActiveFirm from '../../hooks/useActiveFirm';

const ProductProducingForm = ({
                                  error,
                                  loading,
                                  product_options,
                                  addProductProduction,
                                  getProductOptions,
                                  previewProductionMaterials,
                                  currentPage,
                              }) => {
    const { firmId } = useActiveFirm();
    const formRef = useRef();

    const [productOptions, setProductOptions] = useState([]);
    const defaultValues = {
        firm_id: '',
        product_id: '',
        quantity: '',
        date: '',
    };
    const [inputs, setInputs] = useState(defaultValues);
    const [errors, setErrors] = useState({});
    const [materialPreview, setMaterialPreview] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    
    // Auto-populate with global firm
    useEffect(() => {
        if (firmId) {
            setInputs(prev => ({ ...prev, firm_id: firmId }));
            getProductOptions({ firm_id: firmId });
        }
    }, [firmId, getProductOptions]);
    
    // Ensure firm_id is always set from global active firm
    useEffect(() => {
        if (firmId && inputs.firm_id !== firmId) {
            setInputs(prev => ({ ...prev, firm_id: firmId }));
            getProductOptions({ firm_id: firmId });
        }
    }, [firmId, getProductOptions, inputs.firm_id]);

    useEffect(() => {
        let options = [];
        product_options.forEach((item) => options.push({
            label: item.name,
            value: item.id
        }));
        setProductOptions(options);
    }, [product_options]);

    const handleChange = async (e) => {
        if (e.target.name === 'quantity' && parseFloat(e.target.value) < 0) {
            e.target.value = Number(e.target.value) * -1;
        }
        setErrors({});
        
        const newInputs = {...inputs, [e.target.name]: e.target.value};
        setInputs(newInputs);
        
        // Auto-preview when both product and quantity are available
        if (e.target.name === 'quantity' || e.target.name === 'product_id') {
            if (newInputs.product_id && newInputs.quantity && parseFloat(newInputs.quantity) > 0) {
                const previewData = {
                    product_id: newInputs.product_id,
                    quantity: parseFloat(newInputs.quantity)
                };
                
                const result = await previewProductionMaterials(previewData);
                if (result) {
                    setMaterialPreview(result.data);
                    setShowPreview(true);
                } else {
                    setShowPreview(false);
                }
            } else {
                setShowPreview(false);
            }
        }
    }
    const handleSelect = async (data, type) => {
        // Firm selection is handled by global firm switcher, not here
        setErrors({});
        
        const newInputs = {...inputs, [type.name]: data.value};
        setInputs(newInputs);
        
        // Auto-preview when both product and quantity are available
        if (type.name === 'product_id') {
            if (newInputs.product_id && newInputs.quantity && parseFloat(newInputs.quantity) > 0) {
                const previewData = {
                    product_id: newInputs.product_id,
                    quantity: parseFloat(newInputs.quantity)
                };
                
                const result = await previewProductionMaterials(previewData);
                if (result) {
                    setMaterialPreview(result.data);
                    setShowPreview(true);
                } else {
                    setShowPreview(false);
                }
            } else {
                setShowPreview(false);
            }
        }
    };

    const handlePreview = async () => {
        if (!inputs.product_id || !inputs.quantity) {
            setErrors({
                product_id: !inputs.product_id ? 'Mahsulotni tanlang' : '',
                quantity: !inputs.quantity ? 'Miqdorni kiriting' : ''
            });
            return;
        }

        const previewData = {
            product_id: inputs.product_id,
            quantity: parseFloat(inputs.quantity)
        };

        const result = await previewProductionMaterials(previewData);
        if (result) {
            setMaterialPreview(result.data);
            setShowPreview(true);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Ensure firm_id is always included in the form data
        const formData = {
            ...inputs,
            firm_id: firmId || inputs.firm_id || '',
        };
        const params = getParams(true);
        // Always include firm_id from global active firm in params for refetch
        if (firmId) {
            params.firm_id = firmId;
        }
        // Include current page if available
        if (currentPage) {
            params.page = currentPage;
        }
        if (await addProductProduction(formData, params)) {
            setInputs({});
            setMaterialPreview(null);
            setShowPreview(false);
        }
    };
    useEffect(() => {

        if (loading === false) {
            if (error) {
                const errorsItems = error?.errors;
                let errorObject = {};
                if (error.hasOwnProperty('errors')) {
                    Object.keys(error.errors).forEach((item) => errorObject[item] = errorsItems[item][0]);
                }
                setErrors(errorObject);

            } else {
                setErrors({});
                setInputs(defaultValues);
            }
        }
    }, [error, products]);


    return (
        <Fragment>

            <div className="col-md-12 col-lg-8">
                <h3 className="h4 mb-1"><strong>Yangi mahsulot</strong> ishlab chiqarish</h3>
            </div>
            <div className="col-12">

                <Form onSubmit={handleSubmit} ref={formRef}>



                    <div className="mb-2">
                        <label htmlFor="product_id">Mahsulot</label>
                        <Select
                            name={'product_id'}
                            options={productOptions}
                            value={getSelectedOption(inputs?.product_id || '', productOptions)}
                            onChange={handleSelect}
                            defaultValue={{label: 'Tanlang', value: ''}}
                        />
                        <div className="error">
                            {errors?.product_id}
                        </div>
                    </div>

                    {/*<div className="mb-2">*/}
                    {/*    <label htmlFor="warehouse_id">Mahsulot sklad</label>*/}
                    {/*    <Select*/}
                    {/*        name={'warehouse_id'}*/}
                    {/*        options={warehouseOptions}*/}
                    {/*        value={getSelectedOption(inputs?.warehouse_id || '', warehouseOptions)}*/}
                    {/*        onChange={handleSelect}*/}
                    {/*        defaultValue={{label: 'Tanlang', value: ''}}*/}
                    {/*    />*/}
                    {/*    <div className="error">*/}
                    {/*        {errors?.warehouse_id}*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="mb-2">
                        <label htmlFor="quantity">Miqdori</label>
                        <input
                            name="quantity"
                            className={'form-control'}
                            value={inputs?.quantity || ''}
                            type="text"
                            min={1}
                            placeholder={1000}
                            onChange={handleChange}
                            required
                        />
                        <div className="error">
                            {errors?.quantity}
                        </div>
                    </div>

                    {showPreview && materialPreview && (
                        <div className="mb-3">
                            <div className="card">
                                <div className="card-header bg-light">
                                    <h5 className="mb-0">Materiallar ({materialPreview.materials_needed.length})</h5>
                                </div>
                                <div className="card-body" style={{maxHeight: '400px', overflowY: 'auto', overflowX: 'auto'}}>
                                    <div className="table-responsive">
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    {materialPreview.materials_needed.map((material, index) => (
                                                        <th key={index} className="text-center" style={{minWidth: '150px'}}>
                                                            <strong>{material.material_name}</strong>
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Kerak miqdor</strong></td>
                                                    {materialPreview.materials_needed.map((material, index) => (
                                                        <td key={index} className="text-center">
                                                            <span className="text-muted">
                                                                {Number(material.needed_quantity).toLocaleString('uz-UZ', {minimumFractionDigits: 2, maximumFractionDigits: 2})} {material.unit_name}
                                                            </span>
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <td><strong>Mavjud miqdor</strong></td>
                                                    {materialPreview.materials_needed.map((material, index) => (
                                                        <td key={index} className="text-center">
                                                            <span className={material.is_sufficient ? "text-success" : "text-danger"}>
                                                                {Number(material.available_quantity).toLocaleString('uz-UZ', {minimumFractionDigits: 2, maximumFractionDigits: 2})} mavjud
                                                            </span>
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <td><strong>Narx</strong></td>
                                                    {materialPreview.materials_needed.map((material, index) => (
                                                        <td key={index} className="text-center">
                                                            <span className="text-info">
                                                                {Number(material.total_cost).toLocaleString('uz-UZ', {minimumFractionDigits: 2, maximumFractionDigits: 2})} so'm
                                                            </span>
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <td><strong>Yetishmayotgan</strong></td>
                                                    {materialPreview.materials_needed.map((material, index) => (
                                                        <td key={index} className="text-center">
                                                            {!material.is_sufficient ? (
                                                                <span className="text-danger">
                                                                    {Number(material.needed_quantity - material.available_quantity).toLocaleString('uz-UZ', {minimumFractionDigits: 2, maximumFractionDigits: 2})} {material.unit_name}
                                                                </span>
                                                            ) : (
                                                                <span className="text-muted">-</span>
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                                <tr>
                                                    <td><strong>Holat</strong></td>
                                                    {materialPreview.materials_needed.map((material, index) => (
                                                        <td key={index} className="text-center">
                                                            {material.is_sufficient ? 
                                                                <i className="fas fa-check text-success" title="Yetarli"></i> : 
                                                                <i className="fas fa-times text-danger" title="Yetarli emas"></i>
                                                            }
                                                        </td>
                                                    ))}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-8">
                                            <strong>Jami narx:</strong>
                                        </div>
                                        <div className="col-md-4">
                                            <strong className="text-primary">
                                                {Number(materialPreview.total_estimated_cost).toLocaleString('uz-UZ', {minimumFractionDigits: 2, maximumFractionDigits: 2})} so'm
                                            </strong>
                                        </div>
                                    </div>
                                    {!materialPreview.can_produce && (
                                        <div className="alert alert-warning mt-2">
                                            <strong>Diqqat!</strong> Ba'zi materiallar yetarli emas. Ishlab chiqarish mumkin emas.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mb-3">
                        <label htmlFor="date">Sana</label>
                        <input
                            name="date"
                            className={'form-control'}
                            type="date"
                            value={inputs?.date || ''}
                            placeholder={'kiriting'}
                            onChange={handleChange}
                            max={moment().format('YYYY-MM-DD')}
                            // onKeyUp={e => e.target.oldValue = e.target.value}
                        />

                        <div className="error">
                            {errors?.date}
                        </div>
                    </div>


                    <div className="mb-2">
                        <Button 
                            className="" 
                            variant="primary" 
                            type="submit" 
                            disabled={loading || (materialPreview && !materialPreview.can_produce)}
                        >
                            Skladga qo'shish
                            {loading && <ButtonLoader/>}
                        </Button>
                        {materialPreview && !materialPreview.can_produce && (
                            <div className="text-danger small mt-1">
                                Materiallar yetarli emas. Ishlab chiqarish mumkin emas.
                            </div>
                        )}
                    </div>
                </Form>
            </div>
        </Fragment>
    );
};

ProductProducingForm.propTypes = {
    addProductProduction: PropTypes.func.isRequired,
    getProductOptions: PropTypes.func.isRequired,
    getFirmOptionsForManagers: PropTypes.func.isRequired,
    previewProductionMaterials: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    product: state.product,
    products: state.product.products,
    error: state.product.error,
    loading: state.product.loading,
    product_units: state.product.product_units,
    product_options: state.product.product_options,
    warehouse_options: state.product.warehouse_options,
    currentPage: state.product.currentPage,
});


export default connect(mapStateToProps, {
    addProductProduction,
    getProductOptions,
    previewProductionMaterials
})(ProductProducingForm);
